export const PublicApiEndpoints = {
  support: '/public/support' as const,
  salonBySlug: (slug: string): string => `/public/sdm/${slug}` as const,
  activities: (salonId: string): string => `/public/salon/${salonId}/activities` as const,
  booking: (salonId: string): string => `/public/salon/${salonId}/booking` as const,
  calendar: (salonId: string): string => `/public/salon/${salonId}/calendar` as const,
  init: (salonId: string): string => `/public/salon/${salonId}/init` as const,
  timetables: (salonId: string): string => `/public/salon/${salonId}/timetables` as const,
  calendarIcs: (salonId: string): string => `/public/salon/${salonId}/calendar.ics` as const,
} as const;
